import { ErrorBoundary } from '@/components/ui/ErrorBoundary'
import '@/styles/globals.css'
import { appWithTranslation } from 'next-i18next'
import type { AppProps } from 'next/app'
import { Open_Sans } from 'next/font/google'
import Head from 'next/head'

const OpenSans = Open_Sans({
  subsets: ['latin'],
  variable: '--font-os'
})

function App({ Component, pageProps }: AppProps) {
  return (
    <ErrorBoundary>
      <main className={`${OpenSans.variable} font-body h-full bg-chat`}>
        <Head>
          <link rel="shortcut icon" href="/favicon.ico" />
        </Head>
        <Component {...pageProps} />
      </main>
    </ErrorBoundary>
  )
}

export default appWithTranslation(App)
